export const API_KEY = process.env.API_KEY!;
export const PAYMASTER_POLICY_ID = process.env.PAYMASTER_POLICY_ID!;
export const OWNER_MNEMONIC = process.env.OWNER_MNEMONIC!;
